<template lang="html">
  <div id="glossary-page">

    <section class="container content-section">
      <div class="row">
        <div class="col-12 col-title-s1">
          <h3 class="title">Glosario</h3>
        </div>

        <div class="col-12 col-tabs">
          <div class="row justify-content-center">
            <router-link class="box-tab" to="/glosario">
              <div>Número telefónico <span class="d-block"> y SIM CARD</span></div>
            </router-link>
            <router-link class="box-tab" to="/glosario/portabilidad-numerica">
              <div>¿Qué es la portabilidad numérica?</div>
            </router-link>
            <router-link class="box-tab" to="/glosario/coberturas">
              <div>Coberturas</span></div>
            </router-link>
            <router-link class="box-tab" to="/glosario/recargas">
              <div>Recargas</span></div>
            </router-link>
          </div>
        </div>

        <router-view></router-view>

      </div>
    </section>

  </div>
</template>

<script>
export default {
  data(){
    return{}
  },

  methods: {}
}
</script>
